import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  detailedOffer: {
    padding: theme.spacing(0, 2.5),
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.detailedOfferBorder.main}`,
    backgroundColor: theme.palette.bg.main,
    borderRadius: theme.spacing(0.5),
    marginBottom: theme.spacing(2),
  },
  row: {
    display: 'grid',
    width: '100%',
    gridTemplateColumns: '50% 50%',
  },
  cell: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    borderRight: `1px solid ${theme.palette.detailedOfferBorder.main}`,
    borderBottom: `1px solid ${theme.palette.detailedOfferBorder.main}`,
    flex: 1,
    padding: theme.spacing(3),
  },
  heading: {
    fontSize: '14px',
    color: theme.palette.primary.light,
    fontWeight: 600,
  },
  dataText: {
    fontSize: '14px',
    color: theme.palette.black.main,
    fontWeight: 600,
    textAlign: 'left',
  },
  generalPaddingAndWidth: {
    width: 'auto',
    padding: theme.spacing(3),
  },
  recipientBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  tableCell: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flex: 1,
    paddingTop: theme.spacing(1.5),
  },
  recepientText: {
    color: theme.palette.detailedRecipientText.main,
    fontSize: '14px',
    fontWeight: 600,
  },
  offerBox: {
    marginTop: theme.spacing(4),
    backgroundColor: theme.palette.opaque.light,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '100%',
  },
  dimensionBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: theme.spacing(2),
    marginTop: theme.spacing(1.5),
    backgroundColor: theme.palette.secondary.main,
  },
  alignDimension: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  alignDimensionText: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    paddingBottom: '5px',
  },
  installmentsTableCell: {
    border: 'none',
    '&.MuiTableCell-root': {
      padding: '0px',
      border: 'none',
    },
  },
  eulaButton: {
    width: '219px',
    height: '48px',
    border: `1px solid ${theme.palette.detailedOfferBorder.main}`,
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  eulaButtonContainer: {
    margin: theme.spacing(-1.875, 'auto', 3, 3),
  },
  pdfIcon: {
    padding: '12px',
    color: theme.palette.detailedOfferBorder.main,
  },
  link: {
    textDecoration: 'none',
  },
  customAndUsageDimension: {
    marginTop: '24px',
    marginBottom: '24px',
  },
  additionalPricing: {
    fontWeight: 400,
    textAlign: 'left',
    width: '325px',
  },
  fullWidth: {
    width: 'max-content',
  },
  regularText: {
    fontWeight: 400,
  },
  eula: {
    marginBottom: '8px',
  },
  metaTable: {
    width: '489px',
  },
  installmentData: {
    display: 'flex',
    flexDirection: 'row',
    width: '257px',
  },
  eulaContainer: {
    border: '0px',
    width: '257px',
    flex: 0.5,
  },
  headingPadding: {
    paddingTop: theme.spacing(1),
  },
  pricingContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '32px',
  },
  offerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '12px',
  },
  customMessage: {
    fontWeight: 500,
    marginTop: '32px',
    textAlign: 'left',
  },
  dimensionLabelWidth: {
    width: '30%',
  },
  dimensionDescriptionWidth: {
    width: '35%',
    textAlign: 'left',
  },
  fixedTop: {
    marginTop: theme.spacing(0),
  },
  planRow: {
    display: 'flex',
    width: '100%',
  },
  plan: {
    textAlign: 'left',
    width: '100%',
  },
  descriptionTitle: {
    fontSize: '12px',
    color: theme.palette.text.secondary,
  },
  description: {
    fontSize: '14px',
    color: theme.palette.textField.dark,
    margin: `${theme.spacing(0.25, 0)} !important`,
    ['@media (max-width: 600px)']: {
      fontSize: '0.75rem',
    },
  },
  planNameLabelWidth: {
    width: '30%',
  },
  planDecLabelWidth: {
    width: '40%',
  },
  headerTitle: {
    color: theme.palette.textField.main,
    fontSize: '12px',
    fontWeight: 400,
  },
  planTableCell: {
    padding: `${theme.spacing(1)} !important`,
    lineHeight: '1.1rem',
    border: 'none',
    verticalAlign: 'baseLine',
  },
  rowText: {
    color: theme.palette.textField.dark,
    fontSize: '14px',
    fontWeight: 400,
  },
  planTableHader: {
    borderBottom: `1px solid ${theme.palette.detailedOfferBorder.main}`,
  },
  planSectionRow: {
    border: `1px solid ${theme.palette.detailedOfferBorder.main}`,
    borderRadius: '4px',
    padding: theme.spacing(3),
    margin: theme.spacing(2, 0),
  },
  customKeyValue: {
    fontWeight: 500,
    marginTop: theme.spacing(1),
    textAlign: 'left',
  },
  contracts: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    width: '100%',
    height: '100%',
  },
  featuresList: {
    padding: theme.spacing(4),
    backgroundColor: theme.palette.secondary.main,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    height: '100%',
  },
  planHeading: {
    fontSize: '16px',
    color: theme.palette.primary.light,
    fontWeight: 600,
    textAlign: 'left',
  },
  fullCell: {
    borderTop: `1px solid ${theme.palette.detailedOfferBorder.main}`,
  },
  largePaddingCell: {
    padding: theme.spacing(4, 5),
  },
  noBorderCell: {
    flexDirection: 'row',
    padding: theme.spacing(4, 5),
    gap: theme.spacing(4),
    border: 'none',
  },
  rowCell: {
    display: 'grid',
    width: '100%',
    gridTemplateColumns: '100%',
  },
  installment: {
    padding: theme.spacing(4),
    backgroundColor: '#EEF4FB',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    height: '100%',
  },
  featureValue: {
    fontWeight: 500,
  },
  installmentFont: {
    fontSize: '14px',
  },
  gcpHeadingFont: {
    fontSize: '16px',
  },
  noBorder: {
    border: 'none',
  },
  offerStatus: {
    display: 'flex',
    alignItems: 'stretch',
    width: '100%',
    maxWidth: '100%',
    marginLeft: 'auto',
    padding: theme.spacing(1, 1.5),
    backgroundColor: theme.palette.bg.main,
    border: `1px solid ${theme.palette.detailedOfferBorder.main}`,
    borderRadius: theme.spacing(0.375),
    boxSizing: 'border-box',
    marginBottom: theme.spacing(1.25),
  },
  status: {
    width: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    fontSize: '14px',
    color: theme.palette.textField.dark,
    flexShrink: 0,
  },
  divider: {
    width: '1px',
    backgroundColor: theme.palette.dividers.main,
    margin: theme.spacing(0, 2),
    flexShrink: 0,
  },
  errorMessage: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    color: theme.palette.textField.dark,
    fontSize: '14px',
    lineHeight: '1.4',
  },
  statusHeading: {
    fontSize: '13px',
    color: theme.palette.text.secondary,
  },
  statusText: {
    marginTop: theme.spacing(0.5),
  },
  dateAndTime: {
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(2.25),
  }
}))
